import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const toastProperties = {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
}

export const toastSuccess = (message) => {
    toast.success(`✅ ${message}`, {
        position: "top-center",
        autoClose: 2000, // Set the auto close time as needed
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    });
};

export const toastWarning = (msg) => {
    toast.warning(`⚠️ ${msg}!`, {
        ...toastProperties
    });
}

export const toastError = (msg) => {
    toast.error(`⚠️ ${msg}`, {
        ...toastProperties
    });
}

